var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Chat_Icon",
    "data-name": "Chat Icon",
    d: "M14.841,18.231a10.429,10.429,0,0,1-1.715.144,9.564,9.564,0,0,1-4.995-1.34c.135,0,.265.027.4.027,5.46,0,10.007-3.481,10.964-8.058A4.972,4.972,0,0,1,21,12.469a4.907,4.907,0,0,1-1.328,3.282h.015V21ZM1.312,11.053A6.4,6.4,0,0,1,0,7.219C0,3.231,3.819,0,8.531,0s8.531,3.231,8.531,7.219-3.819,7.219-8.531,7.219a9.784,9.784,0,0,1-3.676-.711L1.312,15.75Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.abe3f5c2b6a014359b65a059392579a9.svg";
export { ForwardRef as ReactComponent };